<template>
  <div id="dictManage">
    <div class="showName">{{getName}}</div>
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="状态" prop="dictStatus">
          <el-select
            v-model="originData.dictStatus"
            placeholder="请选择状态"
          >
            <el-option
              label="禁用"
              value="1"
            ></el-option>
            <el-option
              label="启用"
              value="2"
            ></el-option>
            <el-option
              label="全部"
              value=""
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典项名称" prop="dictName">
          <el-input placeholder="请输入字典项名称" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.dictName"></el-input>
        </el-form-item>
        <el-form-item label="字典值" prop="dictValue">
          <el-input placeholder="请输入字典值" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.dictValue"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click='search()'
        >查询</el-button>
        <el-button
          size="small"
          @click='rest()'
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addInfo()'
          v-if="judgeJurisdiction(
          '412814894498271232')"
        >新增字典项</yh-button>
      </div>
    </div>
    <div class="user_table">
      <el-table
        :data="tableData"
        style="width: 100%"
        @row-click="showRow"
      >
        <template slot="empty">
          {{emptyText}}

        </template>
        <el-table-column label="字典项ID" rop='id' width="200">
          <template slot-scope="scope">
            {{scope.row.id}}
          </template>
        </el-table-column>
        <el-table-column  width="200" align="center"  prop="dictTypeName" label="字典类别"/>
        <el-table-column  width="150"  align="center" prop="dictName" label="字典项名称">
          <template slot-scope="scope">
            <span class='productDecoration' @click='findDictDetail(scope.row.id,functionList)' v-html='scope.row.dictName'></span>
          </template>
        </el-table-column>
        <el-table-column prop="dictValue" label="字典值"/>
        <el-table-column width="150" align="center" prop="dictSort" label="排序">
          <template slot-scope="scope">
            <div class="keepOrder">
              <input class="keep_input" style="width:87px;" v-number-only v-model="scope.row.dictSort"  @input="scope.row.dictSort = Number($event.target.value.replace(/\D+/, ''))"/>
              <span v-if="functionList.indexOf('322545417577009152')!='-1'"
                class="span_keep"
                @click="keepOrder(scope.row)"
              >保存</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dictStatus" label="状态">
          <template slot-scope="scope">
            <span>
              <span v-if="parseInt(scope.row.dictStatus)==1">禁用</span>
              <span v-if="parseInt(scope.row.dictStatus)==2">启用</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="200"  prop="dictComment" align="center" label="描述">
        </el-table-column>
        <el-table-column width="200"  align="center" prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            {{scope.row.updateTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column width="200"  align="center"  prop="updateUser" label="更新人ID"/>
        <el-table-column width="100"  align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <span
              class="button--blue"
              @click="modify(scope.row)"
              type="primary"
              v-if="judgeJurisdiction(
          '412816225132826624')"
            >修改</span>
            <span
              class="button--blue"
              @click=" isDisables(scope.row ,'2')"
              v-if="scope.row.dictStatus==='1'&&judgeJurisdiction(
          '412815813562552320')"
            >启用</span>
            <span
              class="button--red"
              @click=" isDisables(scope.row ,'1')"
              v-if="scope.row.dictStatus==='2'&&judgeJurisdiction(
          '412815813562552320')"
            >禁用</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <yh-dialog title="新增字典项" :visible.sync="newdic">
      <el-form
        :model="insertDict"
        class="hide-error"
      >
        <el-form-item
          label="字典项名称"
          prop="dictName"
          required
        >
          <el-input
            v-model="insertDict.dictName"
            placeholder="请输入字典项名称，不超过20字"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典值"
          prop="dictValue"
          required
        >
          <el-input
            v-model="insertDict.dictValue"
            placeholder="请输入字典值，不超过40字"
            maxlength="40"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别"
          prop="dictTypeName"
        >
          <el-input
            v-model="insertDict.dictTypeName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="dictComment"
        >
          <el-input
            type="textarea"
            v-model="insertDict.dictComment"
            maxlength="200"
            placeholder="请输入描述，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="dictSort"
          required
        >
          <el-input
            v-model="insertDict.dictSort"
            placeholder="请输入整数，数值越小显示越靠前"
            maxlength="6"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="newdic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="addLoading"
          @click="insertDictClick()"
        >提交</el-button>
      </span>
    </yh-dialog>
    <yh-dialog title="修改字典项" :visible.sync="modifyDic">
      <el-form
        :model="updateDict"
        class="hide-error"
      >
        <el-form-item
          label="字典项名称"
          prop="dictName"
          required
        >
          <el-input
            v-model="updateDict.dictName"
            placeholder="请输入字典项名称，不能超过20字"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典值"
          prop="dictValue"
        >
          <el-input
            v-model="updateDict.dictValue"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别"
          prop="dictTypeName"
        >
          <el-input
            v-model="updateDict.dictTypeName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="dictComment"
        >
          <el-input
            type="textarea"
            v-model="updateDict.dictComment"
            placeholder="请输入描述，不超过200字"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="dictSort"
          required
        >
          <el-input
            v-model="updateDict.dictSort"
            placeholder="请输入整数，数值越小显示越靠前"
            maxlength="6"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="modifyDic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="uptLoading"
          @click="updateDictClick()"
        >确定</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import { getFunctionList, getPagingData } from '@/mixins';

export default {
  mixins: [getFunctionList, getPagingData],
  data() {
    const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
    return {
      emptyText: this.$LS.empty,
      getName: parentData.dictTypeName,
      // 初始数据
      originData: {
        dictName: '',
        dictValue: '',
        dictStatus: '',
        dictTypeIdentif: JSON.parse(sessionStorage.getItem('dictTypeDetail')).dictTypeIdentif,
      },
      // 查询数据
      searchParam: {
        dictName: '',
        dictValue: '',
        dictStatus: '',
        dictTypeIdentif: JSON.parse(sessionStorage.getItem('dictTypeDetail')).dictTypeIdentif,
      },
      newdic: false,
      modifyDic: false,
      functionList: [],
      insertDict: {
        // 新增数据
        dictName: '',
        dictValue: '',
        dictTypeIdentif: parentData.dictTypeIdentif,
        dictSort: '',
        dictComment: '',
        dictStatus: '',
      },
      updateDict: {
        // 修改数据
        id: '',
        dictName: '',
        dictValue: '',
        dictTypeIdentif: '',
        dictSort: '',
        dictComment: '',
      },
      pageNo: 1,
      currentPage: 1,
      pageSize: 10,
      sumCount: 0,
      tableData: [],
      dictStatus: '',
      addLoading: false,
      uptLoading: false,
      defSortVal: '0',
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.dict_info_query(true);
      },
    },
    'insertDict.dictSort': function (val) {
      if (val !== '') {
        this.insertDict.dictSort = Number(val.toString().replace(/\D+/, ''));
      }
    },
    'updateDict.dictSort': function (val) {
      if (val !== '') {
        this.updateDict.dictSort = Number(val.toString().replace(/\D+/, ''));
      }
    },
  },
  mounted() {},
  directives: {
    numberOnly: {
      bind(el) {
        el.handler = function () {
          if (el.value.length > 6) {
            el.value = el.value.toString().substring(0, 6);
          }
          el.value = Number(el.value.replace(/\D+/, ''));
        };
        el.addEventListener('input', el.handler);
      },
      unbind(el) {
        el.removeEventListener('input', el.handler);
      },
    },
  },
  mounted() {
    this.getJurisdiction();
  },
  methods: {
    // 获取功能权限
    getJurisdiction() {
      const params = {
        data: {
          roleId: JSON.parse(sessionStorage.getItem('sessionData')).roleId,
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
        },
      };
      this.$_post(this.$API.get_role_menu, params).then((res) => {
        console.log(res);
        this.functionList = res.data.roleMenuList;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 判断是否有权限
    judgeJurisdiction(v) {
      for (let index = 0; index < this.functionList.length; index++) {
        if (this.functionList[index].menuId === v) {
          return true;
        }
      }
      return false;
    },
    // 字典类型详情
    dict_info_query(emptyValue) {
      this.getPagingData(this.$API.getDictList, emptyValue, 'dict');
    },
    // 查询
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.dict_info_query();
    },
    // 重置
    rest() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
      this.originData.dictTypeIdentif = JSON.parse(sessionStorage.getItem('dictTypeDetail')).dictTypeIdentif;
      this.searchParam.dictTypeIdentif = JSON.parse(sessionStorage.getItem('dictTypeDetail')).dictTypeIdentif;
    },
    // 单选
    showRow(row) {
      this.updateDict = JSON.parse(JSON.stringify(row));
    },
    // 新增按钮
    addInfo() {
      this.newdic = true;
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      Object.keys(this.insertDict).forEach((key) => {
        this.insertDict[key] = '';
      });
      this.insertDict.dictTypeName = parentData.dictTypeName;
      this.insertDict.dictSort = this.defSortVal;
    },
    // 新增确定
    insertDictClick() {
      if (this.insertDict.dictName === '') {
        this.$message.warning('请输入字典项名称');
        return;
      }
      if (this.insertDict.dictValue === '') {
        this.$message.warning('请输入字典值');
        return;
      }
      if (this.insertDict.dictSort === '') {
        this.$message.warning('请输入排序值');
        return;
      }
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      this.addLoading = true;
      this.$_yh_confirm(
        '字典项新增后将无法删除，确定要新增吗？',
        '新增字典项',
      ).then(() => {
        const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
        const params = {
          data: {
            dictTypeIdentif: parentData.dictTypeIdentif,
            dictName: this.insertDict.dictName,
            dictValue: this.insertDict.dictValue,
            dictSort: this.insertDict.dictSort,
            dictComment: this.insertDict.dictComment,
            dictStatus: 2, // 默认启用
            createUser: userId,
            updateUser: userId,
          },
        };
        this.addDictonary(params);
      }).catch(() => {
        this.addLoading = false;
      });
    },
    addDictonary(params) {
      return this.$_post(this.$API.addDictDetail, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.newdic = false;
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.addLoading = false;
      });
    },
    // 修改按钮
    modify(row) {
      this.modifyDic = true;
      const parentData = JSON.parse(sessionStorage.getItem('dictTypeDetail'));
      this.updateDict = JSON.parse(JSON.stringify(row));
      this.updateDict.dictTypeIdentif = parentData.dictTypeIdentif;
    },
    // 修改校验
    updateDictClick() {
      if (this.updateDict.dictName === '') {
        this.$message.warning('请输入字典项名称');
        return;
      }
      if (this.updateDict.dictSort === '') {
        this.$message.warning('请输入排序值');
        return;
      }
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      const params = {
        data: {
          id: this.updateDict.id,
          dictName: this.updateDict.dictName,
          dictValue: this.updateDict.dictValue,
          dictTypeIdentif: this.updateDict.dictTypeIdentif,
          dictComment: this.updateDict.dictComment,
          dictSort: this.updateDict.dictSort,
          updateUser: updateUserid,
        },
      };
      this.updateDictionary(params);
    },
    // 修改提交
    updateDictionary(params) {
      return this.$_post(this.$API.editDictDetail, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 修改后保存展示顺序
    keepOrder(row) {
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData'))
        .userId;
      const params = {
        data: {
          dictSort: row.dictSort,
          id: row.id,
          updateUser: updateUserid,
        },
      };
      this.$_post(this.$API.editDictSort, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 是否修改禁用启用状态
    isDisables(row, dictStatus) {
      let str = '';
      const name = row.dictName;
      if (dictStatus === '2') {
        str = '启用';
        this.$confirm(`确定要${str}"${name}"字典项?`, `${str}字典项`, {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(row, dictStatus);
          })
          .catch(() => {});
      } else if (dictStatus === '1') {
        str = '禁用';
        this.$confirm(
          `禁用后，前端界面对应的下拉列表中将不显示该字典项(但不影响已产生的历史数据)，确定要${str}"${name}"字典项?`,
          `${str}字典项`,
          {
            confirmButtonText: `${str}`,
            cancelButtonText: '取消',
            closeOnClickModal: false,
          },
        )
          .then(() => {
            this.disables(row, dictStatus);
          })
          .catch(() => {});
      }
    },
    // 修改禁用启用的状态
    disables(row, dictStatus) {
      const updateUserid = JSON.parse(sessionStorage.getItem('sessionData'))
        .userId;
      const params = {
        data: {
          dictStatus,
          id: row.id,
          updateUser: updateUserid,
        },
      };
      this.$_post(this.$API.editDictStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.currentPage = 1;
          this.dict_info_query();
          this.$message.success(this.$MSG.M0031);
          this.search();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
  #dictManage {
    overflow: initial;
  }
 .keep_input {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .keep_input:focus {
    border-color: #54a6de;
    outline: 0;
  }
.showName {
  font-size: 24px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.keepOrder .keep_input {
  width: 50px;
  padding: 2px;
  color: #515974;
}
.keepOrder .span_keep {
  margin-left: 10px;
  color: #1e88ff;
  cursor: pointer;
}
.el-row {
  text-align: center;
}
.el-col {
  margin-top: 10px;
}
</style>
